// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app__modules_study_study_module_ts":"6905465118441ddb","src_app__modules_dashboard_dashboard_module_ts":"5b12384a4b453e6e"}[chunkId] + ".js";
};